import { Flex, Box, Icon, HStack } from '@chakra-ui/react';
import { TbChartBar, TbTable } from 'react-icons/tb';

type ViewType = 'graph' | 'table';

interface ViewToggleProps {
    value: ViewType;
    onChange: (value: ViewType) => void;
}

const ViewToggle = ({ value, onChange }: ViewToggleProps) => {
    return (
        <Flex bg="gray.100" p={0.5} borderRadius="full" gap={1} display="inline-flex">
            {([
                { key: 'graph' as ViewType, label: 'Graph', icon: TbChartBar },
                { key: 'table' as ViewType, label: 'Table', icon: TbTable },
            ]).map(({ key, label, icon }) => (
                <Box
                    key={key}
                    as="button"
                    onClick={() => onChange(key)}
                    borderRadius="full"
                    fontWeight="medium"
                    fontSize="xs"
                    color={value === key ? 'white' : 'gray.500'}
                    bg={value === key ? '#0071E3' : 'transparent'}
                    border="none"
                    py={1}
                    px={3}
                    cursor="pointer"
                    transition="all 0.15s"
                    _hover={{
                        color: value === key ? 'gray.300' : 'gray.700',
                    }}
                >
                    <HStack spacing={1.5}>
                        <Icon as={icon as React.ElementType} boxSize={3.5} />
                        <span>{label}</span>
                    </HStack>
                </Box>
            ))}
        </Flex>
    );
};

export default ViewToggle;
export type { ViewType };

